import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 請求攔截器
api.interceptors.request.use(
  config => {
    // 預覽模式：發送 demo 租戶 slug 讓後端解析到對應租戶
    const previewSlug = sessionStorage.getItem('preview_tenant_slug');
    const isPlatformPreview = sessionStorage.getItem('platform_preview_mode') === 'true';

    // Prevent preview tenant from leaking into normal flows.
    // sessionStorage can survive hard navigations; only attach this header while on /preview/* routes or platform_preview.
    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    const isPreviewRoute = pathname.startsWith('/preview/');

    if (previewSlug && (isPreviewRoute || isPlatformPreview)) {
      config.headers['x-tenant-slug'] = previewSlug;
    }

    // 自動加入 session id
    const sessionId = localStorage.getItem('cart_session_id');
    if (sessionId) {
      config.headers['x-session-id'] = sessionId;
    }

    // 加入用戶手機號碼（用於訂單查詢等）
    const userPhone = localStorage.getItem('user_phone');
    if (userPhone) {
      config.headers['x-user-phone'] = userPhone;
    }

    // Attach auth tokens.
    // Admin pages store `admin_token`, but requests previously didn't include it.
    const url = config.url || '';
    const isAdminApi =
      url.startsWith('/admin') ||
      url.startsWith('/billing') ||
      url.startsWith('/remarketing') ||
      url.startsWith('/tenant-settings') ||
      url.startsWith('/settings') ||
      url.startsWith('/analytics/admin') ||
      url.startsWith('/upload') ||
      url.startsWith('/smilepay') ||
      url.startsWith('/tracking');

    if (isAdminApi) {
      const adminToken = localStorage.getItem('admin_token');
      if (adminToken && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      }
    } else {
      const userToken = localStorage.getItem('authToken');
      if (userToken && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${userToken}`;
      }
    }

    return config;
  },
  error => Promise.reject(error)
);

// 回應攔截器
api.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;
    // Avoid noisy console errors for "expected not found" routes (demo ids, order lookups, etc.).
    if (status !== 404) {
      console.error('API Error:', error.response?.data || error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
